import { Entity } from '@core/api/entity';
import { Field, Model, Name, Type } from '@junte/serialize-ts';
import { NumberSerializer } from './serializers';
import { User } from './user.model';

@Model()
export class Client extends Entity {
  /**
   * Backend numeric primary key (`id` in API). Distinct from {@link Entity.id},
   * which maps from `uid` (UUID used in routes).
   */
  @Field()
  @Name('id')
  @Type(new NumberSerializer())
  public pk: number;

  @Field() companyName: string;
  @Field() advisorUser: User;
  @Field() type: string;
  @Field() firstname: string;
  @Field() surname: string;
  @Field() businessType: string;
  @Field() clientClass: string;
  @Field() investorClientAdviceLicence: boolean;
  @Field() isSemi: boolean;
  @Field() isProfessional: boolean;
  @Field() isEligible: boolean;
  @Field() isBalanceSheetFilledOut: boolean;
  @Field() hasUserLoggedIn: boolean;
  @Field() hasUserInvited: boolean;

  public getFullName(): string {
    return `${this.firstname ?? ''} ${this.firstname} ${this.surname}`.trim();
  }

  public static create(data: Partial<Client>): Client {
    return Object.assign(new Client(), data);
  }
}
